import { atom } from "recoil";

export const NewUserSelectedIndex = atom<number | null>({
  key: "newUserSelectedIndex",
  default: null,
});
